import {
  TableRow,
  TableCell,
  IconButton
} from '@mui/material';
import { DateTime } from 'luxon';

import { useNavigate } from 'react-router-dom';
import {
  menuUtil,
  useAccessState
} from 'modules/common';
import { PlanSetMenu } from 'modules/components/layer19';
import { MoreVert } from '@mui/icons-material';



export type PlanSetRowProps = {
  id: string;
  name: string;
  displayName: string;
  createdAt: DateTime;
  updatedAt: DateTime;
  planCount: number;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSetRowProps) => {
  const navigate = useNavigate();
  const access = useAccessState('PlanSet');
  const {
    anchorEl,
    handleClick,
    handleClose,
    open
  } = menuUtil.useBaseMenuState();


  return (
    <TableRow
      content='list'
      onClick={(e) => {
        e.stopPropagation();
        navigate(`${props.id}`);
      }}
    >
      <TableCell
        variant='firstRounded'
      >
        {props.displayName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.planCount}
      </TableCell>

      <TableCell
        variant='body'
      >
        {props.createdAt.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.updatedAt.toFormat('DDDD')}

      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        <IconButton
          disabled={!access.delete}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClick(e);
          }}
        >
          <MoreVert />
        </IconButton>
        {open && (
          <PlanSetMenu.FC
            open={open}
            anchorEl={anchorEl ?? null}
            handleClick={handleClick}
            handleClose={handleClose}
            id={props.id}
          />
        )}
      </TableCell>
    </TableRow>
  );

};
